import React, { useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import * as Const from "../Const";

function UserConfirmationTab() {

    const paramUserId = useParams().userId;

    const navigation = useNavigate();

    const [userId, setUserId] = useState(paramUserId ?? '');
    const [isUserIdValid, setIsUserIdValid] = useState(null);
    const [code, setCode] = useState("");
    const [isCodeValid, setIsCodeValid] = useState(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    const [errorString, setErrorString] = useState(null);

    const handleUserIdChange = (event) => {
        const v = event.target.value;
        setUserId(v);
        setIsUserIdValid(v.length === 0 ? null : isNaturalNumber(v));
        setIsSubmitDisabled(false);
    };

    const isNaturalNumber = (n) => {
        return n >= 0 && Math.floor(n) === +n;
    };

    const handleCodeChange = (event) => {
        const v = event.target.value;
        setCode(v);
        setIsCodeValid(v.length === 0 ? null : v.length === 4);
        setIsSubmitDisabled(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmitDisabled(true);
        setErrorString(null);

        if (userId && code) {
            const data = {
                token: code,
            };
            const url = Const.API_CLOUD_USERS_VERIFY.replace("%", userId);
            axios
                .post(url, data)
                .then((res) => {
                    console.log("res: " + res);
                    if (res.status === 204) {
                        console.log("res: confirmed");
                        navigation(Const.BASE_NAME + "/user/success");
                    }
                })
                .catch((error) => {
                    console.log("error: " + error);
                    const res = error.response;
                    if (res.status === 404) {
                        console.log("error: not found");
                        setErrorString(`User ID ${userId} not found`);
                        // this.props.navigation("/user/confirm");
                    } else {
                        console.log("error: unknown");
                        // this.props.navigation("/");
                    }

                    setIsSubmitDisabled(false);
                    setIsCodeValid(false);
                });
        }
        else {
            setIsCodeValid(false);
            setIsSubmitDisabled(false);
        }
    };

    const userIdValidationClass = isUserIdValid === true ? "is-valid" : isUserIdValid === false ? "is-invalid" : "";

    const codeValidationClass = isCodeValid === true ? "is-valid" : isCodeValid === false ? "is-invalid" : "";

    return (
        <div className="card">
            <div className={"card-header"}>Confirm E-Mail Address</div>
            <div className={"card-body"}>
                <div className={"row g-3"}>
                    <div className={"col-12 my-3"}>
                        Please check your e-mail and enter {userId ? "" : "the user ID and "} the verification code.
                    </div>
                </div>

                <form className="row g-3 align-items-start" method={"post"}>
                    <div className={"col-12 col-md-4"}>
                        <label className="visually-hidden" htmlFor="form-userid">User ID</label>
                        <div className={"input-group has-validation"}>
                            <span className={"input-group-text"}>User ID</span>
                            <input
                                className={`form-control ${userIdValidationClass}`} type={"text"} name={"form-userid"} placeholder={"User ID"} required={true}
                                value={userId} readOnly={!!userId} onChange={handleUserIdChange} autoComplete={"off"}
                            />
                        </div>
                    </div>

                    <div className={"col-12 col-md-4"}>
                        <label className="visually-hidden" htmlFor="form-code">Verification Code</label>
                        <div className={"input-group has-validation"}>
                            <span className={"input-group-text"}>Code</span>
                            <input
                                className={`form-control ${codeValidationClass}`} type={"text"} name={"form-code"} placeholder={"Code"} required={true}
                                value={code} onChange={handleCodeChange} autoComplete={"off"}
                            />
                        </div>
                    </div>

                    <div className={"col-12 col-md-4"}>
                        <button className={"btn btn-primary w-100"} type={"submit"} onClick={handleSubmit} disabled={isSubmitDisabled}>Submit</button>
                    </div>
                </form>
            </div>

            {errorString ? <div className={"card-body"}>{errorString}</div> : null}

            {/*<div className={"card-footer"}>*/}
            {/*    <div className={"row justify-content-center"}>*/}
            {/*        <div className={"col-12 col-lg-4"}>*/}
            {/*            <a className={"btn btn-secondary w-100"} href={Const.BASE_NAME + "/user/new"}>Register New Account</a>*/}
            {/*        </div>*/}
            {/*    </div>*/}

            {/*    /!*{optionalCloseButton}*!/*/}

            {/*</div>*/}
        </div>
    );
}


export default UserConfirmationTab;
